import Light from './Light';

export default Light;
